// extracted by mini-css-extract-plugin
export default {"container":"Photos_container__iDR7a","container-img":"Photos_container-img__MN5O9"};